import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchExaminationData } from "../redux/slice/examinationPage"
import { retrunAssets } from "../utils/getAssets"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import { DecodeHtml } from "../utils/decodeHtml"
import TabHeaders from "../components/campusLife/tabHeaders"
import Contents from "../components/campusLife/tabContents"
import { useLocation, useNavigate } from "react-router-dom"

const Examination = () => {
    const location = useLocation();
    const state = useSelector(state => state.examination)
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultActiveTab = parseInt(queryParams.get('tab')) || 0;
    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    const handleTabClick = (index) => {
        setActiveTab(index);
        queryParams.set('tab', index);
        navigate({ search: queryParams.toString() });
    };

    useEffect(() => {

        dispatch(fetchExaminationData("student-hub/exam-timetable/"))

    }
        , [dispatch])

    const examination = state?.data?.properties
    const title = examination?.title
    const bg = examination?.backgroundImage != null ? retrunAssets(examination?.backgroundImage[0]?.url) : ""

    const data = examination?.contents?.items?.map(item => {
        item = item?.content?.properties
        return {
            header: item?.title,
            content:<p className="whitespace-pre-line font-medium"> {DecodeHtml({ html: item?.content.markup })}</p>,
        }

    })



    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <div className="flex justify-center w-full p-8 md:p-12">
                <div className="w-full lg:max-w-7xl">
                    <div className="w-full relative  flex flex-col ">
                        <div className="flex w-full bg-cover bg-no-repeat bg-center pt-4 rounded-lg"  style={{ backgroundImage: `url(${bg})` }} >

                            <TabHeaders headers={data?.map(item => item.header)} activeTab={activeTab} handleTabClick={handleTabClick} />
                        </div>
                        <Contents contents={data?.map(tab => tab.content)} activeTab={activeTab} />
                    </div>

                </div>

            </div>
        </AnimatedPage>
    )
}

export default Examination